import {
  Paper,
  Stack,
  Tab,
  Tabs
} from '@mui/material';
import {
  ManageUsersSection,
  ProductsSection
} from 'modules';
import { useState } from 'react';



export type UsersActivityProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const AdminActivity = (props: UsersActivityProps) => {
  const [
    value,
    setValue
  ] = useState(0);

  return (
    <Stack gap={2}>
      <Tabs
        value={value}
        onChange={(_ev, value) => setValue(value)}
      >
        <Tab
          value={0}
          label='Users'
        />

        <Tab
          value={1}
          label='Product Preview'
        />
      </Tabs>

      {value === 0 && (
        <ManageUsersSection.FC />
      )}

      {value === 1 && (
        <Paper sx={{
          borderBottomLeftRadius: '1rem',
          borderBottomRightRadius: '1rem',
          mb: 1
        }}
        >
          <ProductsSection.FC disableButtons />
        </Paper>
      )}
    </Stack>
  );
};
